import { css } from '@emotion/react'
import Image from 'next/image'
import { Dispatch, SetStateAction } from 'react'
import { Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import { ButtonHeart } from 'components/ButtonHeart'
import { IconFactory } from 'components/IconButton'
import { styled } from 'styles/styled'
import { theme } from 'styles/theme'

interface CarouselGalerieProps {
  eventId: number
  handleClose: () => void
  images: string[]
  currentSlide: number
  setCurrentSlide: Dispatch<SetStateAction<number>>
  eventName: string
}

const navigationButtonStyle = styled.div`
  color: ${theme.palette.label.default} !important;
  width: 45px !important;
  height: 45px !important;
  background-color: ${theme.palette.surface.subdued} !important;
  border-radius: 50% !important;
  font-size: 10px !important;
  &::after {
    font-size: 20px !important;
  }
  svg {
    width: auto !important;
    height: auto !important;
  }
`

export const NextButton = styled(navigationButtonStyle)`
  margin-right: 20px;
`

export const PrevButton = styled(navigationButtonStyle)`
  margin-left: 20px;
`

const GalleryButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
`

const ContainerPagination = styled.div`
  font-style: italic;
  font-size: bold;
  color: ${theme.palette.surface.subdued};
  white-space: nowrap;
`

interface IconBackProps {
  icon: string
  onClick: () => void
}
const IconBack = styled(IconFactory)<IconBackProps>`
  cursor: pointer;
  path {
    fill: ${theme.palette.surface.subdued};
  }
`

const CarouselGallery = ({
  eventId,
  handleClose,
  images,
  currentSlide,
  setCurrentSlide,
  eventName
}: CarouselGalerieProps) => (
  <>
    <GalleryButtonContainer>
      <IconBack icon="arrowBack" onClick={handleClose} />
      <ContainerPagination>
        {currentSlide + 1} / {images.length}
      </ContainerPagination>
      <ButtonHeart eventId={eventId} />
    </GalleryButtonContainer>
    <NextButton className="swiper-button-next" />
    <Swiper
      navigation={{
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }}
      initialSlide={currentSlide}
      onSlideChange={(swiper) => setCurrentSlide(swiper.activeIndex)}
      modules={[Pagination, Navigation]}
      className="mySwiper"
      style={{
        height: '80%',
        width: '80%'
      }}
    >
      {images.map((src, index) => (
        <SwiperSlide key={index} style={{ height: '100%', width: '100%' }}>
          <Image
            alt={`${eventName} - image`}
            src={src.trim()}
            fill
            sizes="100vw"
            key={index}
            css={css`
              object-fit: cover;
            `}
          />
        </SwiperSlide>
      ))}
    </Swiper>
    <PrevButton className="swiper-button-prev" />
  </>
)

export default CarouselGallery
